import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { id: "searchOverlayTargetToAdd" }
const _hoisted_2 = { class: "flex flex-col max-h-64 overflow-auto w-full top-36" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_5 = { class: "ml-3 flex items-center gap-x-2" }
const _hoisted_6 = { class: "min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-between items-center px-3 bg-white h-[54px] w-full rounded-b-md border-t border-gray-200"
}
const _hoisted_8 = { class: "flex items-center gap-x-4" }
const _hoisted_9 = { class: "text-base leading-6 font-medium w-fit" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_11 = { class: "flex items-center gap-x-2" }
const _hoisted_12 = { class: "min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }
const _hoisted_13 = { id: "searchOverlayTargetToRemove" }
const _hoisted_14 = { class: "flex flex-col max-h-64 overflow-auto w-full top-36" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_17 = { class: "ml-3 flex items-center gap-x-2" }
const _hoisted_18 = { class: "min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }
const _hoisted_19 = {
  key: 0,
  class: "flex justify-between items-center px-3 bg-white h-[54px] w-full rounded-b-md border-t border-gray-200"
}
const _hoisted_20 = { class: "flex items-center gap-x-4" }
const _hoisted_21 = { class: "text-base contacting-6 font-medium w-fit" }
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_23 = { class: "flex items-center gap-x-2" }
const _hoisted_24 = { class: "min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }

import { computed, onMounted, ref, watch } from "vue"
import { MinusSmIcon, SearchIcon, TrashIcon } from "@heroicons/vue/outline"
import GgmsLoading from "@/components/GgmsLoading.vue"
import CollectionIcon from "@/components/icons/CollectionIcon.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import { useWorkflowStore } from "@/stores/workflow"
import { useCollectionStore } from "@/stores/collection"
import { Collection } from "@/shared/models/collection"
import { debounce } from "@/shared/utils/helpers"


export default /*@__PURE__*/_defineComponent({
  __name: 'MembershipChangedTriggerSidebar',
  setup(__props) {

const collectionStore = useCollectionStore()
const workflowStore = useWorkflowStore()

const searchMenuToAdd = ref()
const toAddSearch = ref("")
const isSearchingToAdd = ref(false)
const isAllToAddSelected = ref(false)
const totalToAdd = ref(0)
const showDataToAdd = ref(false)

const searchMenuToRemove = ref()
const toRemoveSearch = ref("")
const isSearchingToRemove = ref(false)
const isAllToRemoveSelected = ref(false)
const totalToRemove = ref(0)
const showDataToRemove = ref(false)

const toAddCollections = ref<Collection[]>([])
const toRemoveCollections = ref<Collection[]>([])
const data = ref<Collection[]>([])

const selectAllTextToAdd = computed(() =>
    isAllToAddSelected.value ? "Deselect all" : `Select all (${totalToAdd.value})`
)
const selectAllTextToRemove = computed(() =>
    isAllToRemoveSelected.value ? "Deselect all" : `Select all (${totalToRemove.value})`
)

async function getCollections() {
    toAddCollections.value = await collectionStore.searchCollections(toAddSearch.value, "contact")
    toRemoveCollections.value = await collectionStore.searchCollections(toRemoveSearch.value, "contact")
}

function toggleSearchMenuToAdd(event?: Event) {
    searchMenuToAdd.value.show(event)
}

function toggleSearchMenuToRemove(event?: Event) {
    searchMenuToRemove.value.show(event)
}

function clearToAddData() {
    workflowStore.toAdd = []
}

function clearToRemoveData() {
    workflowStore.toRemove = []
}

function onSelectToAdd() {
    if (isAllToAddSelected.value) {
        clearToAddData()
    } else {
        workflowStore.toAdd = toAddCollections.value
    }
    isAllToAddSelected.value = !isAllToAddSelected.value
}

function onSelectToRemove() {
    if (isAllToRemoveSelected.value) {
        clearToRemoveData()
    } else {
        workflowStore.toRemove = toRemoveCollections.value
    }
    isAllToRemoveSelected.value = !isAllToRemoveSelected.value
}

function closeSearchMenuToAdd() {
    showDataToAdd.value = true
    searchMenuToAdd.value.hide()
}

function closeSearchMenuToRemove() {
    showDataToRemove.value = true
    searchMenuToRemove.value.hide()
}

function isElementCheckedToAdd(element: Collection) {
    return !!workflowStore.toAdd.find((el) => el._id === element._id)
}

function onClickToAdd(element: Collection) {
    if (isElementCheckedToAdd(element)) {
        const index = workflowStore.toAdd.findIndex((el) => el._id === element._id)
        workflowStore.toAdd.splice(index, 1)
        return
    }

    workflowStore.toAdd.push(element)
}

function isElementCheckedToRemove(element: Collection) {
    return !!workflowStore.toRemove.find((el) => el._id === element._id)
}

function onClickToRemove(element: Collection) {
    if (isElementCheckedToRemove(element)) {
        const index = workflowStore.toRemove.findIndex((el) => el._id === element._id)
        workflowStore.toRemove.splice(index, 1)
        return
    }

    workflowStore.toRemove.push(element)
}
function deleteDataToAdd(element: Collection) {
    workflowStore.toAdd.splice(workflowStore.toAdd.indexOf(element), 1)
}

function deleteDataToRemove(element: Collection) {
    workflowStore.toRemove.splice(workflowStore.toRemove.indexOf(element), 1)
}

watch(
    () => toAddSearch.value,
    debounce(async () => {
        toAddCollections.value = await collectionStore.searchCollections(toAddSearch.value, "contact")
    }, 250)
)

watch(
    () => toRemoveSearch.value,
    debounce(async () => {
        toRemoveCollections.value = await collectionStore.searchCollections(toRemoveSearch.value, "contact")
    }, 250)
)

watch(
    () => [workflowStore.toAdd, workflowStore.toRemove],
    () => {
        workflowStore.areButtonDisabled = !workflowStore.toAdd.length && !workflowStore.toRemove.length
    },
    { deep: true }
)

onMounted(async () => {
    await getCollections()
    if (workflowStore.toAdd.length) {
        showDataToAdd.value = true
    }

    if (workflowStore.toRemove.length) {
        showDataToRemove.value = true
    }
    totalToAdd.value = toAddCollections.value.length
    totalToRemove.value = toRemoveCollections.value.length
})

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-base leading-6 font-medium text-black" }, "The contact's membership was changed by being", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pt-8" }, "Added to one/more contacts collection", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(GgmsInput, {
        modelValue: toAddSearch.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((toAddSearch).value = $event)),
        class: "w-full mt-4",
        iconStart: _unref(SearchIcon),
        placeholder: "Search",
        onInput: toggleSearchMenuToAdd,
        onClick: toggleSearchMenuToAdd
      }, null, 8, ["modelValue", "iconStart"]),
      _createVNode(_component_OverlayPanel, {
        ref_key: "searchMenuToAdd",
        ref: searchMenuToAdd,
        class: "!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white mx-6 right-1",
        appendTo: "#searchOverlayTargetToAdd"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!toAddCollections.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "No results found"))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(toAddCollections.value, (collection) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: collection._id,
                      class: "flex items-center gap-x-2 px-4 py-3 cursor-pointer border-b border-gray-200 last:border-0",
                      tabindex: "0"
                    }, [
                      _createVNode(GgmsCheckBox, {
                        checked: isElementCheckedToAdd(collection),
                        onClick: ($event: any) => (onClickToAdd(collection))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(CollectionIcon),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(collection?.displayName), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["checked", "onClick"])
                    ]))
                  }), 128)),
              (isSearchingToAdd.value)
                ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(workflowStore).toAdd.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    class: "bg-gray-300 w-4 h-4 rounded-sm cursor-pointer",
                    onClick: clearToAddData
                  }, [
                    _createVNode(_unref(MinusSmIcon), { class: "w-4 h-4" })
                  ]),
                  _createElementVNode("p", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_unref(workflowStore).toAdd.length) + " selected - ", 1),
                    _createElementVNode("span", {
                      class: "font-medium text-primary-color-600 hover:text-primary-color-500 cursor-pointer",
                      onClick: onSelectToAdd
                    }, _toDisplayString(selectAllTextToAdd.value), 1)
                  ])
                ]),
                _createVNode(GgmsButton, { onClick: closeSearchMenuToAdd }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Done")
                  ])),
                  _: 1,
                  __: [2]
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      (showDataToAdd.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).toAdd, (collection) => {
              return (_openBlock(), _createElementBlock("div", {
                key: collection._id,
                class: "flex justify-between items-center border-b border-gray-200 last:border-0 py-2.5 px-2"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(CollectionIcon),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(collection?.displayName), 1)
                ]),
                _createVNode(_unref(TrashIcon), {
                  class: "x-5 h-5 m-1 cursor-pointer",
                  onClick: ($event: any) => (deleteDataToAdd(collection))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "bg-gray-200 w-[445px] -mx-6 mt-5 mb-4" }, null, -1)),
    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-lg contacting-7 font-medium text-black pt-4" }, "Removed from one/more contacts collection", -1)),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(GgmsInput, {
        modelValue: toRemoveSearch.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((toRemoveSearch).value = $event)),
        class: "w-full mt-4",
        iconStart: _unref(SearchIcon),
        placeholder: "Search",
        onInput: toggleSearchMenuToRemove,
        onClick: toggleSearchMenuToRemove
      }, null, 8, ["modelValue", "iconStart"]),
      _createVNode(_component_OverlayPanel, {
        ref_key: "searchMenuToRemove",
        ref: searchMenuToRemove,
        class: "!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white mx-6 right-1",
        appendTo: "#searchOverlayTargetToRemove"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (!toRemoveCollections.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, "No results found"))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(toRemoveCollections.value, (collection) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: collection._id,
                      class: "flex items-center gap-x-2 px-4 py-3 cursor-pointer border-b border-gray-200 last:border-0",
                      tabindex: "0"
                    }, [
                      _createVNode(GgmsCheckBox, {
                        checked: isElementCheckedToRemove(collection),
                        onClick: ($event: any) => (onClickToRemove(collection))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(CollectionIcon),
                            _createElementVNode("div", _hoisted_18, _toDisplayString(collection?.displayName), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["checked", "onClick"])
                    ]))
                  }), 128)),
              (isSearchingToRemove.value)
                ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(workflowStore).toRemove.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: "bg-gray-300 w-4 h-4 rounded-sm cursor-pointer",
                    onClick: clearToRemoveData
                  }, [
                    _createVNode(_unref(MinusSmIcon), { class: "w-4 h-4" })
                  ]),
                  _createElementVNode("p", _hoisted_21, [
                    _createTextVNode(_toDisplayString(_unref(workflowStore).toRemove.length) + " selected - ", 1),
                    _createElementVNode("span", {
                      class: "font-medium text-primary-color-600 hover:text-primary-color-500 cursor-pointer",
                      onClick: onSelectToRemove
                    }, _toDisplayString(selectAllTextToRemove.value), 1)
                  ])
                ]),
                _createVNode(GgmsButton, { onClick: closeSearchMenuToRemove }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Done")
                  ])),
                  _: 1,
                  __: [3]
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      (showDataToRemove.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).toRemove, (collection) => {
              return (_openBlock(), _createElementBlock("div", {
                key: collection._id,
                class: "flex justify-between items-center border-b border-gray-200 last:border-0 py-2.5 px-2"
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(CollectionIcon),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(collection?.displayName), 1)
                ]),
                _createVNode(_unref(TrashIcon), {
                  class: "x-5 h-5 m-1 cursor-pointer",
                  onClick: ($event: any) => (deleteDataToRemove(collection))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})